// extracted by mini-css-extract-plugin
module.exports = {"copyRight":"Footer_copyRight__1grjn"};